import { connect } from 'react-redux'

import { EditDinerProfileModal } from '@components/account/edit'

import coordinators from '@coordinators'
import presenters from '@presenters'
import services from '@services'
import { HandleError } from '@coordinators/composed'

import { DinerProfile } from '@types'

interface State {
  account: any
  editDinerProfile: DinerProfile
  user: any
}

const mapStateToProps = (state: State) => {
  const { account, editDinerProfile: dinerProfile, user } = state

  return {
    account,
    dinerProfile: {
      ...dinerProfile,
      hqId: user.lastLoggedInHq,
      accountId: account.id,
      lastUpdatedBy: `${user.firstName} ${user.lastName}`,
    },
    user,
  }
}

const mapDispatchToProps = () => {
  const {
    RestService,
    AccountService,
    MarketService,
    UIService,
    SettingsService,
  } = services
  const {
    SaveDinerProfile,
    DeleteDinerProfile,
    CloseEditDinerProfileModal,
    LoadMarkets,
    LoadDinerProfiles,
    LoadAccountDinerProfiles,
    AsyncLoadOrderSettings,
    LoadSettings,
    RetryOnTimeout,
  } = coordinators
  const {
    pResponseHeadquarters,
    pRequestSettings,
    pResponseSettings,
    pRequestDinerProfile,
    pResponseDinerProfiles,
  } = presenters.Api
  const { pOrderSettings } = presenters

  const saveDinerProfile = SaveDinerProfile({
    RestService,
    AccountService,
    UIService,
    HandleError,
    pRequestDinerProfile,
  }) as (profile: DinerProfile) => Promise<DinerProfile | null>

  const deleteDinerProfile = DeleteDinerProfile({
    RestService,
    AccountService,
    UIService,
    HandleError,
  })

  const closeModal = CloseEditDinerProfileModal({ AccountService, UIService })

  const loadHeadquarters = LoadMarkets({
    MarketService,
    RestService,
    pResponseHeadquarters,
  })

  const loadDinerProfiles = LoadDinerProfiles({ RestService, HandleError })
  const loadAccountDinerProfiles = LoadAccountDinerProfiles({
    RestService,
    AccountService,
    HandleError,
    pResponseDinerProfiles,
  })

  const loadOrderSettings = AsyncLoadOrderSettings({
    RestService,
    SettingsService,
    pRequestSettings,
    pResponseSettings,
    pOrderSettings,
    LoadSettings,
    RetryOnTimeout,
    HandleError,
  })

  const loadConceptsSettings = LoadSettings({
    RestService,
    SettingsService,
    pRequestSettings,
    pResponseSettings,
    RetryOnTimeout,
    HandleError,
  })('concepts')

  const loadMenuItemSettings = LoadSettings({
    RestService,
    SettingsService,
    pRequestSettings,
    pResponseSettings,
    RetryOnTimeout,
    HandleError,
  })('menuItems')

  return {
    saveDinerProfile,
    deleteDinerProfile,
    closeModal,
    loadHeadquarters,
    loadDinerProfiles,
    loadAccountDinerProfiles,
    loadOrderSettings,
    loadConceptsSettings,
    loadMenuItemSettings,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditDinerProfileModal)
